import React from 'react';

/**
 * Lazy loading with retry logic to handle ChunkLoadError/TypeError: Failed to fetch
 * This happens when a user has an old version of the site and tries to navigate,
 * but the server has new hash filenames for the chunks.
 */
export const lazyWithRetry = (
  componentImport: () => Promise<any>
): React.LazyExoticComponent<any> => {
  return React.lazy(async () => {
    try {
      return await componentImport();
    } catch (error: any) {
      // Logic for retry on ChunkLoadError or Failed to fetch
      console.error('Lazy import failed, attempting reload...', error?.message || error);
      
      // We force a page reload if the import fails
      // This will ensure the user gets the latest asset manifests
      window.location.reload();
      
      // Return a never-resolving promise to keep the UI from crashing
      // while the page is reloading
      return new Promise(() => {});
    }
  });
};

